import(/* webpackMode: "eager" */ "C:\\DC\\projects\\2406mem\\components\\about\\AboutOverview.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\DC\\projects\\2406mem\\components\\about\\AboutSectionRenderer.jsx");
;
import(/* webpackMode: "eager" */ "C:\\DC\\projects\\2406mem\\components\\about\\AwardSlider.jsx");
;
import(/* webpackMode: "eager" */ "C:\\DC\\projects\\2406mem\\components\\about\\Directors.jsx");
;
import(/* webpackMode: "eager" */ "C:\\DC\\projects\\2406mem\\components\\about\\Mision.jsx");
;
import(/* webpackMode: "eager" */ "C:\\DC\\projects\\2406mem\\components\\about\\WhyUs.jsx");
;
import(/* webpackMode: "eager" */ "C:\\DC\\projects\\2406mem\\components\\home\\SectionRenderer.jsx");
